import React from "react";
import { languages } from "src/utils/localization/languages/languages";
import NavItem from "../NavItem/NavItem";

import * as styles from "./LanguageSelector.module.scss";
import { DropDown } from "@silversea-ssc/ui-components-react";
import { AlternateLink } from "src/utils/localization/alternateLinks";
import { Language } from "src/utils/localization/languages/types";

function urlForLanguage(language: Language, alternateLinks: AlternateLink[]) {
  if (!alternateLinks) return `/${language.path}`;
  const altLink = alternateLinks.find((l) => l.ogLangCode == language.ogLang);
  if (altLink) return altLink.path;

  return null;
}

export interface LanguageSelectorProps {
  currentLanguage: Language;
  alternateLinks: AlternateLink[];
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  currentLanguage,
  alternateLinks
}) => {
  const othersLanguages = languages
    .filter((l) => l.code != currentLanguage.code)
    .map((language) => ({
      language: language,
      url: urlForLanguage(language, alternateLinks)
    }))
    .filter((u) => !!u.url);

  return (
    <DropDown
      variant="transparent"
      label={currentLanguage.shortName}
      closeOnClickOutside={true}
      className={styles.languageSelector}
      contentClassName={styles.content}
      contentWrapperClassName={styles.contentWrapper}
      buttonClassName={styles.button}
      expandOnDesktop="absolute"
      expandOnTablet="absolute"
      expandOnMobile="inline"
    >
      <ul className={styles.languageList}>
        {othersLanguages.map(({ language, url }) => {
          if (!url) return null;
          return (
            <li key={language.code}>
              <NavItem variant="primary" expandOnMobile={true}>
                <a href={url} lang={language.ogLang} hrefLang={language.ogLang}>
                  {language.shortName}
                </a>
              </NavItem>
            </li>
          );
        })}
      </ul>
    </DropDown>
  );
};
